// import type { Components } from '@mui/material/styles';

export default function MUISlide() /*: Components['MuiSlide'] */ {
  return {};
}
